export enum VesselPartsParamsEnum {
  SIZE = "size",
  VISIBILITY = "visibility",
  LABELS = "labels",
  SEPARATORS = "separators",
  TAIL_OPTIONS = "tailOptions",
  COLORS = "colors",
  SLOTS = "slots",
}
